import Api from '@api/coupon'
import decorationApi from '@api/decoration'
import { COUPONS_PATH } from '@constant'
import { getMomentTime, isObj } from '@hlj/hlj-utils'
import BaseStore from '@store/table'
import { getMerchantInfo } from '@util'
import { message } from 'hljd'
import pick from 'lodash/pick'
import { action, observable, toJS } from 'mobx'
import moment from 'moment'
import { hashHistory } from 'react-router'

class Store extends BaseStore {
  constructor(id, query) {
    super()
    this.id = id

    // url 为 coupons/detail?type=2 则定位到特殊专享券
    if (query.type == 2) {
      this.coupon_type = '2'
    }

    if (id) {
      this.handleEdit()
    }
  }

  handleEdit = async () => {
    await this.getDetail()
    if (this.condition_of_get == '1') {
      this.handleLogic('edit')
    }
  }

  @observable coupon_type = '1' // '1'普通优惠券  '2'特殊专享券
  @observable property_id = [] // 适合类目  不限选项就不传
  @observable is_limit = false
  @observable isEdit = false
  @observable id = ''
  @observable value = ''
  @observable type = '1'
  @observable money_sill = ''
  @observable provide = null
  @observable valid = null
  @observable total_count = ''
  @observable title = ''
  @observable hidden = '1'
  @observable total_count_tmp = ''
  @observable condition_of_get = '0'
  @observable scope = '1'
  @action
  changeField = type => e => {
    this[type] = isObj(e) ? e.target.value : e
    if (type === 'provide' && !this.valid) {
      this.valid = e
    }
  }
  @action
  editCoupon = async () => {
    let validMsg = this.validation()
    if (validMsg !== 'pass') {
      return message.warn(validMsg)
    }
    let params = this.getEditParams()

    let { success } = await Api.edit(params)
    if (success) {
      hashHistory.push({
        pathname: COUPONS_PATH,
        state: {
          guide: params.id ? false : true
        }
      })
      this.isEdit = false
    }
  }
  @action
  cancel = () => {
    this.coupon_type = '1'
    this.property_id = []
    this.is_limit = false
    this.isEdit = false
    this.id = ''
    this.value = ''
    this.type = '1'
    this.money_sill = ''
    this.provide = null
    this.valid = null
    this.total_count = ''
    this.title = ''
    this.hidden = '1'
    this.total_count_tmp = ''
    hashHistory.push(COUPONS_PATH)
  }
  @action
  getDetail = async () => {
    this.isEdit = true
    let { data, success } = await Api.getDetail({ id: this.id })
    const {
      value,
      type,
      money_sill,
      provide_start,
      provide_end,
      valid_start,
      valid_end,
      total_count,
      title,
      hidden,
      condition_of_get,
      property,
      coupon_type,
      scope,
      scope_set_meals
    } =
      data || {}
    if (!success) return
    this.coupon_type = coupon_type
    this.value = value
    this.scope = scope
    this.mealRecord = scope_set_meals || []
    this.type = type
    this.money_sill = money_sill
    this.provide = [moment(provide_start), moment(provide_end)]
    this.valid = [moment(valid_start), moment(valid_end)]
    this.total_count = total_count
    this.title = title
    this.hidden = hidden
    this.total_count_tmp = total_count
    this.condition_of_get = condition_of_get || '0'
    if (property.length > 0) {
      this.is_limit = true
      this.property_id = property.map(({ property_id }) => property_id)
    } else {
      this.is_limit = false
      this.property_id = []
    }
  }

  validation = () => {
    const {
      title,
      value,
      type,
      money_sill,
      provide,
      valid,
      total_count_tmp,
      total_count,
      isEdit,
      property_id,
      is_limit,
      scope,
      mealRecord
    } = this

    if (!title) {
      return '优惠券名称不能为空'
    }
    if (!value) {
      return '金额不能为空'
    }
    if (!this.id && scope == '2' && !(mealRecord && mealRecord.length)) {
      // 编辑时不校验此项
      return '请选择指定套餐'
    }
    if (
      scope == '2' &&
      mealRecord.find(record => record.actual_price > value)
    ) {
      return '优惠券金额高于所选套餐价格，无法提交！'
    }
    if (type === 1) {
      if (!money_sill) {
        return '满减券的使用金额不能为空'
      }
      if (+money_sill <= +value) {
        return '满减券的使用金额需大于优惠金额'
      }
    }

    if (
      getMerchantInfo().is_franchisee == '1' &&
      is_limit &&
      property_id.length == 0
    ) {
      return '请选择限制类目'
    }

    if (!provide) {
      return '领取时间不能为空'
    }
    if (!valid) {
      return '有效期不能为空'
    }
    if (
      new Date(Date.parse(getMomentTime(toJS(provide), 1))) >
      new Date(Date.parse(getMomentTime(toJS(valid), 1)))
    ) {
      return '领取结束时间不能大于有效结束时间'
    }
    if (!total_count) {
      return '发行量不能为空'
    }
    if (isEdit) {
      if (+total_count_tmp > +total_count) {
        this.total_count = total_count_tmp
        return '二次提交发行量较原来不可减少，已重置为前次发行量'
      }
    }
    return 'pass'
  }

  getEditParams = () => {
    const {
      coupon_type,
      id,
      value,
      type,
      money_sill,
      provide,
      valid,
      total_count,
      title,
      hidden,
      condition_of_get,
      is_limit,
      property_id,
      scope,
      mealRecord
    } = this
    return {
      coupon_type,
      id: id ? id : null,
      value,
      scope,
      scope_set_meal_ids: scope == '2' ? mealRecord.map(({ id }) => id) : '',
      type,
      money_sill,
      total_count,
      title,
      hidden,
      condition_of_get: coupon_type == '1' ? condition_of_get : '0',
      property_id: is_limit ? property_id : null,
      provide_start: getMomentTime(toJS(provide), 0) + ' 00:00:00',
      provide_end: getMomentTime(toJS(provide), 1) + ' 23:59:59',
      valid_start: getMomentTime(toJS(valid), 0) + ' 00:00:00',
      valid_end: getMomentTime(toJS(valid), 1) + ' 23:59:59'
    }
  }

  @action
  changeCondition_of_get = e => {
    this.condition_of_get = e.target.value
    if (e.target.value == '1') {
      // 接口
      if (!this.id) {
        // 新增的情况
        this.handleLogic('add')
      } else {
        // 编辑情况
        this.handleLogic('edit')
      }
    } else if (e.target.value == '0') {
      this.hiddenDisabled = false
    }
  }

  /**
   * 适用范围
   */
  changeScope = e => {
    this.scope = e.target.value
    if (e.target.value == '2') {
      this.type = '2'
    }
  }

  @observable hiddenDisabled = false

  /**
     * 荀彧 5-18 19:08:14
     新建的时候，要是选择对比优惠券，那么要掉借口检查是否已经存在，如果有，那么要强制选择未激活传过来。否则可以自由选择。

     荀彧 5-18 19:10:52
     修改编辑的时候，进入页面调用接口检查，如果存在并且id不等于这个修改编辑的id，那么他要是再选择对比优惠券的话，那么要强制选择不激活。
     id和返回的一样，那么允许修改。如果返回的id为空，那么就允许修改。
     * @param type
     * @returns {Promise.<void>}
     */
  handleLogic = async type => {
    let { data = [], success } = await Api.contrastCouponApi()
    if (success) {
      if (type === 'add') {
        if (data.length <= 0) {
          // 	如果是空数组，表示这个商家没有处于激活状态的对比优惠券。
          this.hiddenDisabled = false
        } else {
          this.hidden = '0'
          this.hiddenDisabled = true
        }
      } else if (type == 'edit') {
        if (data.length > 0) {
          if (
            data.indexOf(Number(this.id)) !== -1 ||
            data.indexOf(String(this.id)) !== -1
          ) {
            this.hiddenDisabled = false
          } else {
            this.hidden = '0'
            this.hiddenDisabled = true
          }
        }
      }
    }
  }

  @observable propertiesList = []
  @action
  getProperties = async () => {
    let { data, success } = await Api.properties()
    if (success) {
      this.propertiesList = data || []
    }
  }

  @action
  changeValue = type => value => {
    this[type] = value
    if (!this.is_limit) {
      this.property_id = []
    }
  }

  /**
   * 选择套餐Modal
   */
  @observable chooseModalVisible = false
  @observable mealRecord = []
  @observable selectedItem = []
  @observable list = []
  @observable mealsLoading = false

  pagination = {
    current: 1,
    pageSize: 8,
    total: 0
  }

  @action
  openChooseModal = () => {
    this.selectedItem = [...this.mealRecord]
    this.chooseModalVisible = true
  }

  @action
  closeChooseModal = () => {
    this.chooseModalVisible = false
  }

  getList = async () => {
    this.mealsLoading = true
    const { current, pageSize } = this.pagination
    const params = {
      is_sold_out: 0,
      status: 1,
      per_page: pageSize,
      page: current,
      commodity_type: 0 // 0套餐 1案例
    }
    let { success, data } = await decorationApi.mealList(params)
    this.mealsLoading = false
    if (success) {
      data = data || {}
      this.list = data.list || []
      this.pagination.total = Number(data.total_count)
    } else {
      this.list = []
    }
  }

  // 选择套餐弹框里的点击
  @action
  selectItem = item => {
    const selectedIndex = this.selectedItem.findIndex(({ id }) => item.id == id)
    if (selectedIndex > -1) {
      this.selectedItem.splice(selectedIndex, 1)
      this.selectedItem = [...this.selectedItem]
    } else if (this.selectedItem.length >= 5) {
      message.warn('最多选择5个套餐')
    } else {
      this.selectedItem.push(pick(item, ['id', 'title', 'cover_path']))
    }
  }

  // 在页面内直接删除已选的套餐
  deleteSelected = id => {
    const selectedIndex = this.mealRecord.findIndex(item => item.id == id)
    if (selectedIndex > -1) {
      this.mealRecord.splice(selectedIndex, 1)
      this.mealRecord = [...this.mealRecord]
    }
  }

  changeItem = () => {
    this.mealRecord = this.selectedItem || []
    this.closeChooseModal()
  }

  onMealsPageChange = page => {
    this.pagination.current = page
    this.getList()
  }
}

export default Store
